export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

export const convertToMinutes = (hhmm: string): number => {
  const [hours, minutes] = hhmm.split(':').map(Number);
  return (hours * 60) + minutes;
};